import { useCopy, usePropsObject } from "@/lib/contexts/appContext"
import { useTemplate, usePostType } from "@/lib/helpers/template"
import Logo from "@/common/logos/logo"

import Primary from "./menus/primary"
import Content from "./content"
import Newsletter from "./newsletter"
import styles from "./footer.module.css"
import classNames from "classnames"

export default function Footer() {
  const copy = useCopy()
  const object = usePropsObject()
  const postType = usePostType()
  const template = useTemplate()
  const { hideForm, content } = copy.footer
  const { year, publisher } = copy.general
  const hasContent = content && content.length > 0

  const classes = [
    styles.footer,
    {
      "has-green-bg": object?.bgColor === "green",
      "has-related":
        template === "article" &&
        postType !== "bmv-project" && // Related should render white and not regular light-blue for some reason
        object?.related?.posts?.length > 0
    }
  ]

  return (
    <footer className={classNames(classes)}>
      {!hideForm && <Newsletter />}
      <div className="inner-wrapper">
        <div className="logos">
          <Logo className="logo" />
        </div>
        <Primary />
        <Content />
        <div
          className={classNames("bottom-row", { "has-content": hasContent })}>
          <span className="publisher">
            &copy; {year} {publisher}
          </span>
        </div>
      </div>
    </footer>
  )
}
